import React, { useEffect, useState, useReducer } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { WithApiAccess } from "../lib/HigherOrderComponents/WithApiAccess";
import { withHeaderMessages } from "../higherOrderComponents/WithHeaderMessages";
import { EnhancementRequestModal } from "./EnhancementRequest";
import { DistributionQuoteModal } from "./DistributionQuoteModal";
import HomePageCards from "./HomePageCards";
import ToastMessage from "./ToastMessage";
import { useNavigate } from "react-router-dom";
import { canAcceptCreditCard } from "../utils/providers";
import qs from 'qs';

export function Home(props) {
	const initialState = {
		isUserLoading: true,
		users: {},
	};

	const reducer = (state, action) => {
		switch (action.type) {
			case "users":
				return {
					...state,
					users: action.payload,
				};
			case "isUserLoading":
				return {
					...state,
					isUserLoading: action.payload,
				};
			default:
				throw new Error();
		}
	};

	const [homeState, dispatch] = useReducer(reducer, initialState);
	const navigate = useNavigate();

	const CreditCardPaymentDescription = 'Easy access to contract credit card payment processing.';
	const userGuideDescription = 'Get started with the Client Portal with these helpful step by step instructions.';
	const enhancementRequestDescription = 'Share with us your ideas for improving the Client Portal.';
	const distributionQuoteDescription = 'Obtain the payout value of a contract at the click of a button.'
	const libraryDescription = 'Online repository of Legal Updates, ClearPoint News, and fillable service forms.'
	useEffect(() => {

		const search = async (searchTerm, page, pageSize, orderBy, orderByDesc) => {
			let search = {
				Query: searchTerm,
				Options: {
					Page: page,
					ResultsPerPage: pageSize,
					Sort: {
						Name: orderBy,
						Descending: orderByDesc
					}
				},
			};

			let searchQueryString = qs.stringify(search, { allowDots: true, encode: false, addQueryPrefix: true });

			await props.api.get("/api/contracts/search" + searchQueryString)
				.then(response => {
					if (response.status === 200) {
						return response.data;
					}
				})
				.then(data => {
					async function getPayOffDetails() {
						await props.api.get(`/api/contract/${data.results[0].number}/payoff`);
					}
					if (data.results.length > 0) {
						getPayOffDetails();
					}
				})
				.catch()
		}

		search("", 1, 1);
	}, []);

	useEffect(() => {
		async function getCustomerProfile() {
			await props.api
				.get("/api/user")
				.then((response) => {
					if (response.status === 200) {
						return response.data;
					}
				})
				.then((data) => {
					dispatch({ type: "users", payload: data });
				})
				.then(dispatch({ type: "isUserLoading", payload: false }))
				.catch(dispatch({ type: "isUserLoading", payload: false }));
		}
		getCustomerProfile();
	}, []);

	const [show, setShow] = useState(false);
	const [requestSent, setRequestSent] = useState(false);
	const [showDistributionModal, setShowDistributionModal] = useState(false);

	const downloadFile = async () => {
		await props.api
			.getBlob(`/api/documentation/userguide`)
			.then((response) => {
				if (response.status === 200) {
					var filename = "";
					var disposition = response.headers["content-disposition"];
					if (disposition && disposition.indexOf("attachment") !== -1) {
						var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
						var matches = filenameRegex.exec(disposition);
						if (matches != null && matches[1]) {
							filename = matches[1].replace(/['"]/g, "");
						}
					}
					return {
						filename: filename,
						blob: new Blob([response.data], { type: response.data.type }),
					};
				}
			})
			.then((file) => {
				let blobUrl = window.URL.createObjectURL(file.blob);

				let anchor = document.createElement("a");
				anchor.href = blobUrl;
				anchor.download = file.filename;
				document.body.appendChild(anchor);
				anchor.click();
				setTimeout(function () {
					document.body.removeChild(anchor);
					window.URL.revokeObjectURL(blobUrl);
				}, 100);
			});
	};

	const handleCreditCardPayment = () => {
		window.open('/payment', '_blank')
	}

	const handleEnhancementRequest = () => {
		setShow(true)
	}

	const handleDistrubutionQuoteRequest = () => {
		setShowDistributionModal(true)
	}

	const handleLibraryRequest = () => {
		navigate('/library')
	}

	const handleToast = () => {
		setRequestSent(false);
	};

	const { users } = homeState;

	return (
		<Container className="mt-4 col-12 ps-0">
			<Row>
				<ToastMessage
					message={"Request sent"}
					delay={5000}
					show={requestSent}
					handleToast={handleToast}
					type={"success"}
				/>
				<EnhancementRequestModal
					show={show}
					setShow={setShow}
					api={props.api}
					setRequestSent={setRequestSent}
				/>
				<DistributionQuoteModal
					show={showDistributionModal}
					setShow={setShowDistributionModal}
					api={props.api}
				/>
				<Col className="col-10">
					<div>
						<h2>Welcome to the ClearPoint Client Portal!</h2>
						<p>
							Your secure digital gateway to contract level details, payment
							history, reports, submitting distribution quotes, access your
							trust account, view your profile, and more.
						</p>
						<p>Please make sure you bookmark this page for easy access.</p>
					</div>
          <Row>
            <HomePageCards 
              cardName='user-guide' 
              description={userGuideDescription} 
              handleClick = {downloadFile} />
            <HomePageCards 
              cardName='enhancement-request' 
              description={enhancementRequestDescription}
              handleClick={handleEnhancementRequest} />
            <HomePageCards 
              cardName='distribution-quote' 
              description={distributionQuoteDescription}
              handleClick={handleDistrubutionQuoteRequest} />
            <HomePageCards 
              cardName='library'
              description={libraryDescription}
              handleClick={handleLibraryRequest} />
					{users.customers &&
						users.customers.length > 0 &&
						users.acceptCreditCard &&
						canAcceptCreditCard(users.customers)
						&& (
              <HomePageCards 
              cardName='credit-card-payment' 
              description={CreditCardPaymentDescription}
              handleClick={handleCreditCardPayment} />
						)}
          </Row>
				</Col>
			</Row>
		</Container>
	);
}

export default withHeaderMessages(WithApiAccess(Home));
